import React from "react";
import { Redirect } from 'react-router-dom';
import { Routes } from '../Core/Constants';
import { Link } from 'react-router-dom';
import { UserProvider } from './../Providers/UserProvider';
import { Storage } from './../Core/Storage';

export default class Orders extends React.Component {
	state = {
	    orders:[]
	}
    componentDidMount = () => {
		UserProvider.getOrders((data) => {
			window.gtm.loadAccount("orders");
			this.setState({ orders: data });

        })
	}
	
    render() {
        if (!Storage.instance().isAuthorized())
            return (
                <Redirect to={Routes.Login} />);

        let orders = this.state.orders;
		var T = window.Texts.orders;
		if (this.state.success)
			return <Redirect to={Routes.SucessRegistration} />;

		return (
            <div className="orders-page">
                <div className="cover">
                    <div className="headline">
                        <h1>{T.ordersTitle}</h1>
                    </div>
                    {orders.length == 0 ?
                        <div className="orders">{T.empty}</div> :
                        <div className="orders">
                            <ul className="order order-headline">
                                <li className="number">
                                    <p>
                                        <span>{T.catNum}</span>
                                    </p>
                                </li>
                                <li className="date">
                                    <p>
                                        <span>{T.placedOn}</span>
                                    </p>
                                </li>
                                <li className="state">
                                    <p>
                                        <span>{T.state}</span>
                                    </p>
                                </li>
                                <li className="price">
                                    <p>
                                        <span>{T.price}</span>
                                    </p>
                                </li>
                            </ul>
                            {orders.map((order) => {
                               return <ul className="order order-line" key={order + order.id}>
                                    <li className="number">
                                        <p>
                                            <span>{T.catNum + ':'} </span>
                                            <Link to={Routes.Order + '/' + order.id}>{order.invoiceCode}</Link>
                                        </p>
                                    </li>
                                    <li className="date">
                                        <p>
                                            <span>{T.placedOn + ':'}  </span>
                                            {order.created}
                                        </p>
                                    </li>
                                    <li className="state">
                                        <p><span>Stav: </span>
                                            {order.displayState}
                                        </p>
                                    </li>
                                    <li className="price">
                                        <p>
                                            <span>{T.price + ':'}</span>
                                            {order.priceTable.displayTotalPriceInclVat} <small>( {order.priceTable.displayTotalPriceExclVat} bez DPH)</small>
                                        </p>
                                    </li>
                                </ul>
                            })}
                        </div>}
    </div> 
</div>
		);
	}
}

